<script setup lang="ts">
import IconButton from '../IconButton/IconButton.vue';
import { ref } from 'vue';
import { useClipboard } from '../useClipboard';

const props = defineProps<{
  value: string;
  copyTooltip: string;
}>();

const emits = defineEmits<{
  copied: [];
}>();

const clipBoard = useClipboard();
const isOpen = ref(false);

const copy = async () => {
  isOpen.value = true;
  await clipBoard.copy(props.value, false);
  emits('copied');
  setTimeout(() => {
    isOpen.value = false;
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  }, 1000);
};
</script>

<template>
  <div
    class="focus-within:border-primary-500 flex h-[42px] items-center rounded-md border-1 border-neutral-300 px-1"
  >
    <div class="relative flex-1">
      <input disabled class="w-full" type="text" :value="props.value" />
      <div
        class="pointer-events-none absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center bg-white p-2 whitespace-nowrap transition-all duration-150"
        :class="[isOpen ? 'opacity-100' : 'opacity-0']"
      >
        {{ props.copyTooltip }}
      </div>
    </div>
    <IconButton variant="ghost-neutral" icon="copy" @click="copy()" />
  </div>
</template>
